import { MedicalConditionsCateogryModel } from '../../../models/consultation-process/medical-conditions-category.model';
import { MedicalConditionsModel } from '../../../models/consultation-process/medical-conditions.model';
import { OnInit, Component, Input, Inject } from '@angular/core';
import { AppConstants } from '../../../shared/constants/constants';
import { FormControl } from '@angular/forms';
import { DialogService } from '../../../shared/services/dialog.service';
import { MedicalConditionsService } from '../../consultation-process/medical-conditions/medical-conditions.service';
import { MdOptionSelectionChange, MdDialog, MD_DIALOG_DATA, MdDialogRef } from '@angular/material';
import { ConsultationProcessService } from '../../consultation-process/consultation-process.service';
import { GenderType } from '../../../models/consultation/patient.model';
import { Utility } from '../../../common/utility';
import { AppMessages } from '../../../shared/constants/messages';
import { MedicalConditionPopupComponent } from '../../consultation-process/medical-conditions/new-condition-popup.component';
import { MenstrualPeriodComponent } from '../../consultation-process/medical-conditions/menstrual-period.component';

@Component({
    templateUrl: 'medical-condition-popup.component.html',
    providers: [MedicalConditionsService, ConsultationProcessService],
    styles: [
        `md-spinner {
        width: 24px;
        height: 24px;
        margin: 5px 10px 0px 0px;
        top: 0;
        right: 0;
        position: absolute;
      }`,
        `.form-group {
        width: 100%;
      }`,
        `.form-select, .mat-option{
        font-size: 14px
      }`
    ],
})

export class MedicalConditionHistoryPopupComponent implements OnInit {
    public klass = 'medicalConditions';
    public newVaccineName = '';
    public categorySelected: MedicalConditionsCateogryModel = null;
    public categories: Array<MedicalConditionsCateogryModel> = [];
    public medicalConditions: Array<MedicalConditionsModel> = [];
    public medicalConditionsToAdd: Array<MedicalConditionsModel> = [];
    public medicalConditionsSelected: Array<any> = [];
    public medicalConditionsToRemove: Array<any> = [];
    public gender: number;
    public isPregnant = false;
    public lastMenstrualPeriod = null;
    public lastMenstrualPeriodTimeStamp = null;
    public appConstants = AppConstants;
    public consultationId = '';
    public patientInfoSubscription: any;
    selectedSearchMedicalCondition: MedicalConditionsModel;
    searchList: Array<MedicalConditionsModel>;
    quickSearchCtrl: FormControl;
    isSearching = false;
    height: string;
    constructor(public dialogService: DialogService,
        public medicalConditionService: MedicalConditionsService,
        public consultationProcessService: ConsultationProcessService,
        public utility: Utility,
        public dialogRef: MdDialogRef<MedicalConditionHistoryPopupComponent>,
        @Inject(MD_DIALOG_DATA) public data: {
            patientId: string,
            consultationHistoryId: string,
            isFromConsultationHistory: boolean,
            height: number
        }
    ) {
        this.quickSearchCtrl = new FormControl();
        this.quickSearchCtrl.valueChanges.subscribe(keyword => {
            if (keyword) {
                if (keyword.length > 2) {
                    if (this.isSearching) { return; }
                    this.isSearching = true;
                    this.medicalConditionService.quickSearchMedicalCondition(keyword, this.data.patientId, false).subscribe(result => {
                        this.isSearching = false;
                        if (result) {
                            const dataCallback = result.json();
                            const tempArr = <Array<MedicalConditionsModel>>dataCallback;
                            this.searchList = [];
                            if (this.medicalConditionsSelected) {
                                let i = 0;
                                const lens = tempArr.length;
                                while (i < lens) {
                                    const index = this.medicalConditionsSelected.findIndex(x => x.medicalConditionId === tempArr[i].id);
                                    if (index < 0) {
                                        this.searchList = this.searchList.concat(tempArr[i]);
                                    }
                                    i++;
                                }
                            } else {
                                this.searchList = tempArr;
                            }
                        }
                    }, error => { this.isSearching = false; });
                }
            }
        });
    }

    ngOnInit() {
        this.height = this.data.height ? (
            (this.data.height > 599 ?
                ((this.data.height - (this.data.height * 40 / 100)).toString() + 'px') :
                (this.data.height - (this.data.height * 50 / 100)).toString() + 'px')
        ) : 'inherit';
        this.medicalConditionService.getConsultationMedicalCondition(this.data.consultationHistoryId).subscribe(
            (result) => {
                if (result) {
                    this.medicalConditionsSelected = result.json();
                    this.consultationProcessService.getPatientData(this.data.patientId).subscribe(
                        (res) => {
                            if (res) {
                                const patientDetail = res.json();
                                this.gender = patientDetail.sexId;
                                this.getCategories(this.gender);
                            }
                        }
                    );
                }
            }
        );
    }
    getCategories(gender) {
        this.medicalConditionService.getMedicalConditionCategories(gender).subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.categories = data;
                    this.categorySelected = this.categories[this.categories.findIndex(item => item.isDefault === true)] || null;
                    this.getMedicalCondition();
                }
            }
        );
    }

    //  Filter vaccine related to selected category
    getMedicalCondition() {
        if (this.categorySelected) {
            this.medicalConditionService.getMedicalCondition(this.categorySelected.id, this.data.patientId).subscribe(
                (result) => {
                    if (result) {
                        this.medicalConditions = result.json();
                        // set checked to medicalcondition item if it was selected
                        this.medicalConditions.forEach((condition, pos, arr) => {
                            condition['checked'] = false;
                            this.medicalConditionsToAdd.forEach(conditionAdd => {
                                if (conditionAdd['medicalConditionId'] === condition.id) {
                                    condition['checked'] = true;
                                }
                            });
                        });
                        if (this.medicalConditionsSelected.length > 0) {
                            this.medicalConditionsSelected.forEach((medical, pos, arr) => {
                                this.medicalConditions = this.removeDuplicateMedical(medical, this.medicalConditions);
                            });
                        }
                        this.checkMedicalConditionCategory();
                    }
                }
            );
        }
    }

    checkMedicalConditionCategory() {
        this.medicalConditionsSelected.forEach(condition => {
            const index = this.medicalConditions.findIndex(item =>
                (item.id === condition.medicalConditionId));
            if (index >= 0) {
                this.medicalConditions.splice(this.medicalConditions.findIndex(item => item.id === condition.medicalConditionId), 1);
            }
        });
    }

    // behavior when click button add
    selectMedicalCondition() {
        this.medicalConditionsToAdd.forEach(condition => {
            this.medicalConditionsSelected.push(condition);
        });
        this.reSetMedicalConditionsToAdd();
    }

    // behavior when click button remove
    removeMedicalCondition() {
        this.medicalConditionsToRemove.forEach(condition => {
            this.medicalConditionsSelected.splice(this.medicalConditionsSelected.findIndex(item =>
                item.medicalConditionId === condition.medicalConditionId), 1);
        });
        this.reSetMedicalConditionsToRemove();
        this.getMedicalCondition();
    }


    // open dialog to add new condition
    openAddMedicalConditionDialog() {
        this.dialogService.openComponentDialog(MedicalConditionPopupComponent, null, { width: '400px' }).subscribe(result => {
            if (result && result !== '') {
                let isDuplicate = false;
                this.medicalConditionsSelected.forEach(selected => {
                    if (selected.id === null && result === selected.name) {
                        this.dialogService.openErrorDialog({
                            message: Utility.stringFormat(AppMessages.medicalCondition.addDuplicateCondition, [result])
                        });
                        isDuplicate = true;
                    }
                });
                if (!isDuplicate) {
                    const temp = {
                        id: null,
                        categoryId: null,
                        name: result,
                        isOtherMedicalCondition: true,
                        isPregnant: false
                    };
                    this.medicalConditionsSelected.push(temp);
                }
            }
        });
    }

    // checking if button add can be activated
    onCheckButtonAdd() {
        if (this.medicalConditionsToAdd.length < 1) {
            return true;
        }
        return false;
    }

    // checking if button remove can be activated
    onCheckButtonRemove() {
        if (this.medicalConditionsToRemove.length < 1) {
            return true;
        }
        return false;
    }

    // reset temp array for vaccines to add
    reSetMedicalConditionsToAdd() {
        this.getMedicalCondition();
        this.medicalConditionsToAdd = [];
    }

    // reset temp array for vaccines to remove
    reSetMedicalConditionsToRemove() {
        this.medicalConditionsToRemove = [];
    }

    // create temp array for vaccines to add
    onCheckAddList(event, item) {
        const index = this.medicalConditionsToAdd.findIndex(condition => condition.id === item.id);
        if (event.checked && index === -1) {
            this.setMedicalModel(item);
            this.medicalConditionsToAdd.push(item);
        } else if (index >= 0) {
            this.medicalConditionsToAdd.splice(index, 1);
        }
        this.onCheckButtonAdd();
    }

    // create temp array for medicalConditions to remove
    onCheckRemoveList(event, item) {
        const index = this.medicalConditionsToRemove.findIndex(condition => (condition.id != null) ?
            (condition.id === item.id) : (condition.name === item.name));
        if (event.checked && index === -1) {
            this.medicalConditionsToRemove.push(item);
        } else if (index >= 0) {
            this.medicalConditionsToRemove.splice(index, 1);
        }
        this.onCheckButtonRemove();
    }

    submitData() {
        if (this.isDataValid()) {
            this.medicalConditionsSelected.forEach(vaccine => {
                if (vaccine.isPregnant) {
                    this.isPregnant = true;
                }
                delete vaccine['condition'];
            });
            const data = {
                consultationId: this.data.consultationHistoryId,
                isPregnant: this.isPregnant,
                lastMenstrualPeriodTimeStamp: this.lastMenstrualPeriodTimeStamp,
                medicals: this.medicalConditionsSelected,
                isFromConsultationHistory: this.data.isFromConsultationHistory
            };
            this.medicalConditionService.updateMedicalCondition(this.data.consultationHistoryId, data, false).subscribe(
                (result => {
                    if (result) {
                        const dataCallback = result.json();
                        this.onCloseDialog(true);
                        // this.dialogService.openSuccessDialog({ message: data.message });
                    }
                }
                )
            );

        }

    }

    isDataValid() {
        let isPregnantQuestionAsked = false;
        if (this.gender === GenderType.Female) {
            this.medicalConditionsSelected.forEach(condition => {
                if (condition.isPregnantAsked === true) {
                    isPregnantQuestionAsked = true;
                }
            });

            // if female but did not answer
            if (!isPregnantQuestionAsked) {
                this.dialogService.openErrorDialog({ message: 'Please answer pregnancy question.' });
                return false;
            }
            return true;
        }
        return true;
    }

    removeDuplicateMedical(medical, medicalArr = []) {
        if (medicalArr) {
            if (medicalArr.length > 0) {
                const index = this.medicalConditions.findIndex(x =>
                    x['medicalConditionId'] === medical.id || x.id === medical.id);
                if (index > -1) {
                    medicalArr.splice(index, 1);
                }
                return medicalArr;
            }
        }
        return [];
    }

    addMedicalFromSearch(event: MdOptionSelectionChange, medical: MedicalConditionsModel) {
        if (medical) {
            const index = this.medicalConditionsSelected.findIndex(x => x.medicalConditionId === medical.id || x.id === medical.id);
            if (this.medicalConditionsToAdd.length > 0) {
                const temp = this.medicalConditionsToAdd.findIndex(x => x.id === medical.id || x['medicalConditionId'] === medical.id);
                if (temp > -1) {
                    this.medicalConditionsToAdd.splice(temp, 1);
                }
            }
            if (index < 0) {
                this.setMedicalModel(medical);
                this.medicalConditionsSelected.push(medical);
                this.getMedicalCondition();
            }
            this.searchList = [];
            event.source.value = '';
        }
    }

    setMedicalModel(medical) {
        if (!medical.hasOwnProperty('medicalConditionId')) {
            medical['medicalConditionId'] = medical.id;
            medical['id'] = null;
        }
    }


    onCloseDialog(isSuccess = false) {
        this.dialogRef.close(isSuccess);
    }

    openMenstrualPeriodDialog(medical) {
        const lastPeriod = medical.lastMenstrualPeriod || null;
        this.dialogService.openComponentDialog(MenstrualPeriodComponent, lastPeriod, { width: '350px' })
            .subscribe(result => {
                if (result.isSuccess) {
                    if (result.date && result.date !== null) {
                        this.lastMenstrualPeriod = new Date(result.date);
                        medical.lastMenstrualPeriod = this.lastMenstrualPeriod;
                        this.lastMenstrualPeriodTimeStamp = new Date(result.date).getTime() / 1000;
                        medical.lastMenstrualPeriodTimeStamp = this.lastMenstrualPeriodTimeStamp;
                    }
                }
            });
    }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-history/medical-condition/medical-condition-popup.component.ts